import { apiClient } from '@/api/api'
import type { GiftConfig, GiftSubmitResult } from '../types/gift-config'
import { mockGiftConfig } from './mock-gift-config'

export interface GiftSubmitRequest {
  giftConfigId: string
  answers: Record<string, any>
  metadata?: {
    completedAt?: string
    deviceType?: string
    language?: string
  }
}

export async function fetchGiftConfig(): Promise<GiftConfig> {
  try {
    const response = await apiClient.get<GiftConfig>('/gift/config')
    return response.data
  } catch (error) {
    // Fallback to mock config if backend is not available
    console.warn('Failed to fetch gift config from backend, using mock config:', error)
    return mockGiftConfig
  }
}

export async function submitGiftAnswers(data: GiftSubmitRequest): Promise<GiftSubmitResult> {
  try {
    const response = await apiClient.post<GiftSubmitResult>('/gift/submit', data)
    return response.data
  } catch (error) {
    console.error('Error submitting gift answers:', error)
    throw error
  }
}

